import { Controller } from '@hotwired/stimulus'

// Custom nested form controller that appends new items (not prepends)
export default class extends Controller {
  static targets = ['target', 'template']
  static values = {
    wrapperSelector: { type: String, default: '.nested-form-item' }
  }

  add (event) {
    event.preventDefault()

    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime().toString())
    this.targetTarget.insertAdjacentHTML('beforeend', content)
  }

  remove (event) {
    event.preventDefault()

    const wrapper = event.target.closest(this.wrapperSelectorValue)
    if (!wrapper) return

    // If it's a new record, just remove the element
    if (wrapper.dataset.newRecord === 'true') {
      wrapper.remove()
      return
    }

    // Otherwise mark for destruction and hide
    const destroyInput = wrapper.querySelector('input[name*="_destroy"]')
    if (destroyInput) {
      destroyInput.value = '1'
    }
    wrapper.style.display = 'none'
  }
}
